import { Component, inject, signal, ViewChild } from '@angular/core';
import { TitleComponent } from '../../../shared/components/title-component/title-component';
import { SearchBarComponent } from '../../../shared/components/search-bar-component/search-bar-component';
import { MatCardModule } from '@angular/material/card';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatAnchor, MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { DatePipe, UpperCasePipe } from '@angular/common';
import { MatSpinner } from '@angular/material/progress-spinner';
import { Groupe } from '../../model/groupe';
import { ToastrService } from '../../../shared/services/toastr-service';
import { SweetAlertService } from '../../../shared/services/sweet-alert-service';
import { MatDialog } from '@angular/material/dialog';
import { GroupeService } from '../../service/groupe-service';
import { GroupeModal } from '../modal/groupe-modal/groupe-modal';

export interface ModalDataI{
  title : string
  update ?: boolean
  data ?: Groupe
}

@Component({
  selector: 'app-groupe-component',
  imports: [
    TitleComponent,
    SearchBarComponent,
    MatCardModule,
    MatPaginator,
    MatPaginatorModule,
    MatSort,
    MatSortModule,
    MatTableModule,
    MatAnchor,
    MatIconModule,
    MatTooltip,
    MatButtonModule,
    UpperCasePipe,
    MatSpinner,
    DatePipe
  ],
  templateUrl: './groupe-component.html',
  styleUrl: './groupe-component.css',
})
export class GroupeComponent {
  displayedColumns: string[] = ['id', 'name', 'status', 'editor', 'date', 'actions'];
  dataSource!: MatTableDataSource<Groupe>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  loading = false

  searchValue = signal<string>('')

  currentGroupe = signal<Groupe>(new Groupe())
  readonly dialog = inject(MatDialog);


  constructor(
    private toastr : ToastrService,
    private sweetAlert : SweetAlertService,
    private groupeService : GroupeService
  ){
    this.dataSource = new MatTableDataSource<Groupe>([]);
  }

 ngOnInit(): void {
    this.loading = true
    this.groupeService.getAll().subscribe({
      next : (res) =>{
        console.log(res);
        this.dataSource.data = res
        this.loading = false
      },
      error : (err) =>{
        this.loading = false
      }
    })
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event : string){

    this.searchValue.update(val => event)
    this.dataSource.filter = event.trim().toLocaleLowerCase()

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


  openAddGroupeModal(){
    const data : ModalDataI = {
          title : 'Ajouter un Groupe',
          data : new Groupe()
    }

    const dialogRef = this.dialog.open(GroupeModal, {
      width : '600px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : Groupe) => {

      if (result?.id != undefined) {
        const data : Groupe[] = []
        data.push(...this.dataSource.data)
        data.push(result)

        this.dataSource.data = data
        this.toastr.success("Le Groupe "+ result.name + " à été ajouté")
      }
    });
  }

  openUpdate(groupe : Groupe){
    this.currentGroupe.set(groupe)

    const data : ModalDataI = {
      title : 'Modifier le groupe ' + groupe.name,
      update : true,
      data : this.currentGroupe()
    }

    const dialogRef = this.dialog.open(GroupeModal, {
      width : '1000px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : Groupe) => {

      if (result?.id != undefined) {
        const i = this.dataSource.data.findIndex(item => item.id == result.id)
        const data = this.dataSource.data
        data[i] = result
        this.dataSource.data = data
        this.toastr.success("Le groupe "+ result.name + " à été modifie")
      }
    });
  }

  confirm(groupe : Groupe){
    this.sweetAlert
    .confirm('Etez-vous sur de vouloir supprimer le groupe '+ groupe.name)
    .then((res) =>{
      if(res.isConfirmed){
        this.groupeService.delete(groupe.id).subscribe({
          next : (r) =>{
            this.dataSource.data = this.dataSource.data.filter(item => item.id != groupe.id)
            this.sweetAlert.success('Suppression reussie', 2000)
          }
        })
      }
    })
  }

  onChange(collaborateur : Groupe){
    const title = collaborateur.disable?'Activation':'Desactivation'
    const action = collaborateur.disable?'activer':'desactiver'
    this.sweetAlert.confirm('Etez-vous sur de vouloir ' + action)
    .then((res) =>{
      if(res.isConfirmed){
        this.groupeService.changeStatus(collaborateur.id).subscribe({
          next : (result) =>{
            const i = this.dataSource.data.findIndex(item => item.id == result.id)
            const data = this.dataSource.data
            data[i] = result
            this.dataSource.data = data
            this.sweetAlert.success('Operaton reussie', 2000)
          }
        })
      }
    })
  }

}
